




import Vue from 'vue'
import { Chart, registerables } from 'chart.js'

Chart.register(...registerables)

export default Vue.extend({
  props: ['chartType', 'chartData', 'chartOptions'],
  data() {
    return {
      chart: null
    }
  },
  methods: {
    chartConstructor(chartType: any, chartData: any, chartOptions: any) {
      const chartElement = document.querySelector('canvas')
      this.chart = new Chart(chartElement, {
        type: chartType,
        data: chartData,
        options: chartOptions
      })
    }
  },
  mounted() {
    let { chartType, chartData, chartOptions } = this
    this.chartConstructor(chartType, chartData, chartOptions)
  },
  watch: {
    chartData() {
      this.chart.destroy()
      this.chartConstructor(this.chartType, this.chartData, this.chartOptions)
    }
  }
})
